var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRepeat)?_c('div',{staticClass:"tag tag--white tooltip",attrs:{"data-tooltip":"Repeated Task"}},[_c('i',{staticClass:"fa fa-wrapper fa-recycle",staticStyle:{"color":"green"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }